<template>
  <b-card class="card-congratulation-medal">
    <template v-if="currentWeek || lastWeek">
      <!-- Текущая (незавершённая) неделя с прогрессом от средней прибыли -->
      <template v-if="currentWeek">
        <h5>
          {{ currentWeek.week_name }}
          <b-badge variant="light-primary" class="align-middle">текущая</b-badge>
        </h5>
        <b-card-text class="font-small-3 mb-50">
          {{ formatPeriod(currentWeek.period) }} · {{ currentWeek.games_count }} игр · {{ currentWeek.players_count }} игроков
        </b-card-text>
        <h3 class="mb-50" :class="`text-${profitVariant(currentWeek.profit)}`">
          {{ formatRub(currentWeek.profit) }}
        </h3>
        <template v-if="currentWeek.profit_progress_pct !== null && currentWeek.profit_progress_pct !== undefined">
          <b-progress :value="progressValue" :max="100" :variant="progressVariant" height="8px" class="mb-25" />
          <b-card-text class="font-small-2 text-muted mb-0">
            {{ formatPct(currentWeek.profit_progress_pct) }} от средней прибыли ({{ formatRub(currentWeek.avg_profit) }})
          </b-card-text>
        </template>
      </template>

      <hr v-if="currentWeek && lastWeek">

      <!-- Последняя завершённая неделя -->
      <template v-if="lastWeek">
        <b-card-text class="font-small-3 mb-25">
          {{ lastWeek.week_name }} · {{ formatPeriod(lastWeek.period) }} · {{ lastWeek.games_count }} игр
        </b-card-text>
        <h4 class="mb-50" :class="`text-${profitVariant(lastWeek.profit)}`">
          {{ formatRub(lastWeek.profit) }}
        </h4>
        <div class="d-flex flex-wrap align-items-center">
          <b-badge :variant="`light-${deltaVariant(delta.profit_pct)}`" class="mr-50 mb-50">
            прибыль {{ formatDelta(delta.profit_pct) }} к среднему
          </b-badge>
          <b-badge :variant="`light-${deltaVariant(delta.revenue_pct)}`" class="mb-50">
            выручка {{ formatDelta(delta.revenue_pct) }}
          </b-badge>
        </div>
        <b-button
          variant="primary"
          size="sm"
          class="mt-50"
          :to="{ name: 'finance-week-detail', params: { id: lastWeek.week_id } }"
        >
          Детали недели
        </b-button>
      </template>
    </template>
    <div v-else class="text-muted py-3">
      Нет недель в снапшоте
    </div>
    <b-img :src="require('@/assets/images/illustration/badge.svg')" class="congratulation-medal" alt="Медаль" />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BButton, BImg, BBadge, BProgress,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatRub, formatPeriod, profitVariant } from '@/views/finance/utils'
import { formatDelta, deltaVariant } from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BCardText, BButton, BImg, BBadge, BProgress,
  },
  props: {
    business: { type: Object, default: null },
  },
  setup(props) {
    const lastWeek = computed(() => (props.business && props.business.last_week) || null)
    const currentWeek = computed(() => (props.business && props.business.current_week) || null)
    const delta = computed(() => (props.business && props.business.delta) || {})

    const progressValue = computed(() => {
      const pct = currentWeek.value ? currentWeek.value.profit_progress_pct : null
      if (pct === null || pct === undefined) return 0
      return Math.min(Math.max(pct, 0), 100)
    })

    const progressVariant = computed(() => {
      if (!currentWeek.value) return 'primary'
      if (currentWeek.value.profit < 0) return 'danger'
      return currentWeek.value.profit_progress_pct >= 100 ? 'success' : 'primary'
    })

    const formatPct = value => `${new Intl.NumberFormat('ru-RU').format(Math.round(value))} %`

    return {
      lastWeek, currentWeek, delta, progressValue, progressVariant, formatPct,
      formatRub, formatPeriod, profitVariant, formatDelta, deltaVariant,
    }
  },
}
</script>
